export enum MedicalEntityTypes {
  G_HOSPITAL = 'G_Hospital',
  HOSPITAL = 'Hospital',
  CLINIC = 'Clinic',
  POLY_CLINIC = 'Poly_Clinic',
}
